module.exports = __webpack_public_path__ + "static/portfolio1c-5309b52e66f03ccfaa24c3cfb1f369e0.jpg";